import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronSelectorVertical = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7 15L12 20L17 15M7 9L12 4L17 9",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		fill: "none"
	})
});
export default SvgChevronSelectorVertical;
